"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _dsWeb = require("@olxbr/ds-web");
var _propTypes = require("prop-types");
var _style = require("./style");
var _TitleModal = _interopRequireDefault(require("./components/TitleModal"));
var _ListTips = _interopRequireDefault(require("./components/ListTips"));
var _GoItButton = _interopRequireDefault(require("./components/GoItButton"));
var _Rating = _interopRequireDefault(require("./components/Rating"));
var _actions = require("../../../actions");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var ModalTip = function ModalTip(_ref) {
  var title = _ref.title,
    content = _ref.content,
    rating = _ref.rating,
    button = _ref.button,
    analytics = _ref.analytics,
    clickCloseModalAction = _ref.clickCloseModalAction,
    viewSecurityTipModalAction = _ref.viewSecurityTipModalAction,
    open = _ref.open,
    setOpen = _ref.setOpen,
    hasCloseButton = _ref.hasCloseButton;
  var handleViewModal = function handleViewModal() {
    var view = analytics.view;
    viewSecurityTipModalAction(view.type, view.name, view.detail, view.data);
  };
  var handleCloseModal = function handleCloseModal() {
    var dismiss = analytics.dismiss;
    clickCloseModalAction(dismiss.type, dismiss.name, dismiss.detail, dismiss.data);
    setOpen(false);
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_dsWeb.Modal, {
    id: title.text,
    open: open,
    closeCallback: function closeCallback() {
      return handleCloseModal();
    },
    closeable: hasCloseButton,
    onAfterOpen: handleViewModal,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_TitleModal["default"], {
      title: title,
      iconAction: false
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.Content, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ListTips["default"], {
        list: content,
        iconAction: true
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_GoItButton["default"], {
      button: button,
      rating: rating,
      close: handleCloseModal
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Rating["default"], {
      rating: rating
    })]
  });
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _actions.bindActionCreators)({
    clickCloseModalAction: _actions.clickCloseSecurityTipModal,
    viewSecurityTipModalAction: _actions.viewSecurityTipModal
  }, dispatch);
};
ModalTip.propTypes = {
  title: _propTypes.object.isRequired,
  content: _propTypes.object.isRequired,
  rating: _propTypes.object.isRequired,
  button: _propTypes.object.isRequired,
  analytics: _propTypes.object.isRequired,
  clickCloseModalAction: _propTypes.func.isRequired,
  viewSecurityTipModalAction: _propTypes.func.isRequired,
  open: _propTypes.bool.isRequired,
  setOpen: _propTypes.func.isRequired
};
var _default = exports["default"] = (0, _actions.connect)(null, mapDispatchToProps)(ModalTip);